<template>
  <div class="landingPage wrapper">
    <!-- eslint-disable -->
    <ciaHeader />
    <div class="page">
      <div class="page__inner cia-container txt">
        <h1>
          Dofinansowanie
        </h1>
        <p>Pro-Inwest s.c. A. Dobrowolski, D. Dobrowolska, M. Dobrowolska w Katowicach zrealizował projekt finansowany ze środków Unii Europejskiej w ramach działania 3.2 RPO WSL: „Wzrost konkurencyjności firmy poprzez wprowadzenie nowej i innowacyjnej usługi jaką jest uruchomienie Centrum Innowacyjnej Archiwizacji w Katowicach”.  Projekt realizowany w okresie: czerwiec 2017 do października 2018r.</p>
        <h2>Cele projektu:</h2>
        <p>Celem projektu było wprowadzenie do oferty firmy nowych i innowacyjnych usług poprzez uruchomienie Centrum Innowacyjnej Archiwizacji w Katowicach.</p>
        <p>Cele szczególne to:</p>
        <ol>
          <li>wdrożenie innowacji produktowej- stworzenie kompleksowej usługi archiwizacji danych i obiektów (niezależnie od ich formatu i postaci: fizyczna, cyfrowa), będzie to pierwsza tego rodzaju usługa w skali kraju – Archiwum 3D.</li>
          <li>Wzrost konkurencyjności firmy na rynku regionalnym i krajowym</li>
          <li>Rozwój usług archiwizacyjnych a przede wszystkim archiwizacji 3D.</li>
        </ol>
        <h2>Planowane efekty:</h2>
        <p>Wprowadzenie nowych usług do firmy: wydruk 3D, skanowanie3D, skanowanie dokumentów, niszczenie, przechowywanie dokumentacji papierowej, jak również innowacyjną na skalę kraju usługę archiwizacji 3D w chmurze z dedykowanym programem do zarządzania posiadanymi zasobami. Pozwala ona na archiwizację: danych, przedmiotów, urządzeń, projektów.</p>
        <p>W ramach projektu stworzono specjalistyczną technologię do gromadzenia/przechowywania przesyłania, przetwarzania i rozpowszechniania informacji w formie elektronicznej (dedykowany, nowy program do obsługi archiwum) z wykorzystaniem technik cyfrowych i wszelkich narzędzi komunikacji elektronicznej, który zostanie udostępniony klientom.<br/>
          Zakupiono komputery ze specjalistycznym oprogramowaniem, zapewniające realizację usług i sprawną komunikację pomiędzy obsługą a klientem oraz bezpieczeństwo usług.
        </p>
        <p>
          <strong>Wartość projektu:</strong> 1 964 540,01 PLN<br/>
          <strong>Wydatki kwalifikowane:</strong> 1 597 187 PLN<br/>
            <strong>Wkład Funduszy Europejskich:</strong> 718 733,65 PLN<br/>
        </p>
      </div>
    </div>
    <ciaFooter />
    <!-- eslint-enable -->
  </div>
</template>

<script>
import ciaHeader from './../components/LandingPage/ciaHeader.vue';
import ciaFooter from './../components/LandingPage/Footer.vue';

export default {
  name: 'Regulations',
  components: {
    ciaHeader,
    ciaFooter,
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700&subset=latin-ext');
  @import "./../scss/landingpage.scss";
</style>
